<template>
  <div>
    <div class="container">

      <div class="page-title">
        <span class="name">Copie d'inventaire</span>
      </div>

      <Tabs>

        <TabSection title="Copie d'inventaire">
          <div class="columns">
            <div class="column">
              <div>À copier dans</div>
            </div>
            <div class="column">
              <select v-model="toCompany" v-if="this.companies">
                <option :value="null"></option>
                <option :value="c.id" v-for="c of this.companies">{{ c.name }}</option>
              </select>
            </div>
            <div class="column"></div>
          </div>
          <div class="columns">
            <div class="column">
              <div>À partir de</div>
            </div>
            <div class="column">
              <select v-model="fromCompany" v-if="this.companies">
                <option :value="null"></option>
                <option :value="c.id" v-for="c of this.companies">{{ c.name }}</option>
              </select>
            </div>
            <div class="column"></div>
          </div>
          <button class="btn btn-primary" :disabled="actionDone" @click="copyFrom">Copier</button>
        </TabSection>

      </Tabs>

    </div>
  </div>
</template>

<script>
import { Core } from '@/core/Core';

export default {
  name: "CloneInventory",

  data() {
    return {
      actionDone: false, /* avoid multiple clone*/
      branchId: null,
      fromCompany: null,
      toCompany: null,
      companies: null
    };
  },

  mounted() {
    this.branchId = this.$route.query.branch;
    if (this.branchId) {
      Core.request("GET", `/api/branches/${this.branchId}/companies`)
        .then((companies) => {
          this.companies = companies.map(c => ({ id: c.id, name: c.name }))
        })
    }
  },

  methods: {
    copyFrom() {
      let fromCompany = this.fromCompany;
      let toCompany = this.toCompany;
      if (!toCompany || !fromCompany || fromCompany === toCompany) {
        toast("Vous devez sélectionner deux compagnies différentes", "error");
        return
      }
      this.actionDone = true;
      this.$store.commit("showSpinner", true);
      Core.request("PUT", `/api/branches/${this.branchId}/companies/${toCompany}/change-inventory`, { cloneFromCompany: fromCompany })
        .then(() => {
          toast("L'inventaire à été cloner avec succès", "success");
          this.$router.push(this.$router.buildContext("/categories", { company: toCompany }))
        })
        .catch(() => {
          this.actionDone = false
        })
        .finally(() => {
          this.$store.commit("showSpinner", false);
        })
    }
  },

}
</script>

<style lang="scss" scoped></style>